<script lang="ts">
    import MeetingManagerPage from '@Evaluation/CriteriaSurveys/Pages/MeetingManagerPage'
    export default MeetingManagerPage
</script>

<template>
    <div>
        <CriteriaSurveyAccessLinks :viewModel="criteriaSurveyAccessLinks"
                                   @show-email-sender="showCriteriaSurveyEmailSender"
                                   @download-links="handleDownloadAccessLinks" />

        <CriteriaSurveyEmailSender :viewModel="criteriaSurveyEmailSender"
                                   @send-email="handleSendEmailCommand" />


        <CriterionDetailsDialog :viewModel="criterionDetailsDialog" />


        <MeetingStarterDialog :propOpened="meetingStarterOpened" :propSurveyStarted="SurveyStarted" :propAutoRevealEnabled="AutoRevealEnabled" :propNamesRevealed="NamesRevealed"
                              @start-meeting="handleStartMeetingCommand"
                              @start-survey="handleStartSurveyCommand"
                              @stop-survey="handleStopSurveyCommand"
                              @toggle-auto-reveal="ToggleAutoRevealCommand"
                              @toggle-names-revealed="ToggleNamesRevealedCommand"
                              @show-access-links="ShowAccessLinksCommand"
                              @close-dialog="meetingStarterOpened = false" />

        <MeetingStopperDialog :propOpened="meetingStopperOpened" :propSurveyStarted="SurveyStarted"
                              @stop-meeting="handleStopMeetingCommand"
                              @start-survey="handleStartSurveyCommand"
                              @stop-survey="handleStopSurveyCommand"
                              @close-dialog="meetingStopperOpened = false" />

        <DisagreementsReportDialog :propOpened="disagreementsReportOpened" :propRm="disagreementReport"
                                   @show-question="handleShowDisagreementsQuestion"
                                   @close-dialog="disagreementsReportOpened = false" />

        <PanelConsistencyAnalysisDialog :propOpened="consistencyAnalysisOpened" :propRm="consistencyAnalysis"
                                        @show-question="handleShowInconsistentQuestion"
                                        @close-dialog="consistencyAnalysisOpened = false" />

        <SurveyOpenerDialog :propOpened="surveyOpenerOpened" :propSurveyId="surveyId"
                            @start-survey="handleStartSurveyCommand"
                            @show-access-links="ShowAccessLinksCommand"
                            @close-dialog="surveyOpenerOpened = false" />

        <SurveyCloserDialog :propOpened="surveyCloserOpened" :propSurveyId="surveyId"
                            @stop-survey="handleStopSurveyCommand"
                            @close-dialog="surveyCloserOpened = false" />

        <PortfolioNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <template v-if="initialized === false">
            <div class="container-fluid" style="padding-top: 130px;">
                <h3><i class="fa fa-spinner fa-spin"></i> Loading...</h3>
            </div>
        </template>

        <template v-if="initialized">

            <nav class="navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-center">
                <div class="btn-group" role="group">
                    <button @click="PreviousQuestionCommand" type="button" class="btn btn-secondary">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> <span>Prev question</span>
                    </button>

                    <button v-if="AllQuestionsAnswered === false" @click="NextUnansweredQuestionCommand" type="button" class="btn btn-warning" title="Go to next unanswered question">
                        Next unanswered
                    </button>
                    <button v-if="AllQuestionsAnswered === true" @click="AllDoneCommand" type="button" class="btn btn-success" title="Go to next unanswered question">
                        All done
                    </button>

                    <button @click="NextQuestionCommand" type="button" class="btn btn-secondary">
                        <span>Next question</span> <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                </div>
            </nav>

            <div class="container-fluid" style="padding-top: 130px;">
                <div class="row">
                    <div class="col-6">
                        <h6 class="mx-5">
                            <a class="text-dark" v-sanitizedHref="`/#/pp/criteria-surveys/${workspaceId}/${projectId}/${evalModelId}`">
                                <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back to weights
                            </a>
                        </h6>
                        <h1 class="my-0 mx-5" style="font-size: 2em; font-weight: 300; color: #33475b;">Panel: {{Name}}</h1>
                    </div>
                    <div class="col-6 col-lg-5 text-right col align-self-end">

                        <div v-if="MeetingStarted === false">
                            <button type="button" class="btn btn-success" @click="showMeetingStarterCommand">Start Meeting</button>

                            <button type="button" class="btn btn-outline-secondary" v-if="SurveyStarted === false" @click="surveyOpenerOpened = true">Open Survey</button>
                            <button type="button" class="btn btn-outline-secondary" v-if="SurveyStarted === true" @click="surveyCloserOpened = true">Close Survey</button>

                            <button type="button" class="btn btn-outline-secondary" @click="ShowAccessLinksCommand">
                                Access links
                            </button>

                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    Analyze votes
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="showDisagreementsReport">Disagreements</a>
                                    <a class="dropdown-item" @click="showConsistencyAnalysis">Consistency</a>
                                </div>
                            </div>
                        </div>

                        <div v-if="MeetingStarted === true">

                            <div class="btn-group">
                                <button type="button" class="btn btn-warning" @click="ToggleVotesRevealedCommand">
                                    <i :class="VotesRevealed === true ? 'fa-regular fa-fw fa-square-check' : 'fa-regular fa-fw fa-square'"></i> Reveal votes
                                </button>
                                <button type="button" class="btn btn-warning dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"></button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item px-1" @click.stop="ToggleAutoRevealCommand">
                                        <i :class="AutoRevealEnabled === true ? 'fa-regular fa-fw fa-square-check' : 'fa-regular fa-fw fa-square'"></i> Auto reveal
                                    </a>
                                    <a class="dropdown-item px-1" @click.stop="ToggleNamesRevealedCommand">
                                        <i :class="NamesRevealed === false ? 'fa-regular fa-fw fa-square-check' : 'fa-regular fa-fw fa-square'"></i> Anonymous
                                    </a>
                                </div>
                            </div>

                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    Analyze votes
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="showDisagreementsReport">Disagreements</a>
                                    <a class="dropdown-item" @click="showConsistencyAnalysis">Consistency</a>
                                </div>
                            </div>

                            <div class="btn-group">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                    Actions
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="meetingStopperOpened = true">Stop Meeting</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" v-if="SurveyStarted === false" @click="surveyOpenerOpened = true">Open Survey</a>
                                    <a class="dropdown-item" v-if="SurveyStarted === true" @click="surveyCloserOpened = true">Close Survey</a>
                                    <a class="dropdown-item" @click="ShowAccessLinksCommand">Access links</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <hr style="border-color: #bbb; margin: 20px 0 60px;" />
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12" style="padding-bottom: 100px;">
                        <div class="card">
                            <div class="card-header">
                                Questions <strong>{{AnsweredQuestionsCount}}/{{QuestionsCount}}</strong>
                            </div>
                            <div class="card-body">
                                <div class="dropdown">
                                    <a class="h5 dropdown-toggle" data-toggle="dropdown" style="white-space: normal;">
                                        {{CurrentContext?.Name}}
                                    </a>
                                    <div class="dropdown-menu" style="max-height: 300px; overflow-y:auto;">
                                        <div class="input-group px-3 mb-1">
                                            <input type="search" placeholder="Search..." class="form-control" v-model="SearchPhrase">
                                            <span class="input-group-append">
                                                <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                                            </span>
                                        </div>
                                        <a class="dropdown-item" @click="SetCurrentContext(c.CriterionId)" v-for="c in EvalContextsView" :key="c.CriterionId">
                                            {{c.Name}}<br />
                                            <small>{{c.Path}}</small>
                                        </a>
                                    </div>
                                </div>

                                <div class="list-group mt-2">
                                    <a class="list-group-item list-group-item-action" v-for="q in QuestionsView" :key="q.QuestionId" @click="SwitchQuestion(q.QuestionId)"
                                       :class="{'bg-secondary text-white': CurrentQuestionId === q.QuestionId}">

                                        <i :class="getQuestionCssClass(q)"></i>
                                        {{q.FirstCriterionName}} vs. {{q.SecondCriterionName}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-7 offset-lg-1 col-md-9 col-sm-8 col-xs-12" style="padding-bottom: 100px;">
                        <MeetingQuestionReview :readModel="Question"
                                               @show-criterion-details="showCriterionDetails"
                                               @update-value="handleSavePanelVoteCommand"
                                               @update-comment="handleSavePanelVoteCommentCommand">
                        </MeetingQuestionReview>
                    </div>
                </div>
            </div>



        </template>


    </div>
</template>

<style scoped>
    div.Evaluation-MeetingManager {
        width: 100%;
        height: 100%;
        max-height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0;
        padding-top: 80px;
        background-color: #fff;
    }

</style>
